module.exports = __webpack_public_path__ + "static/media/12C_CNG.143fa761.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/tco/assets/12C_CNG.jpg
// module id = 1480
// module chunks = 0